function inputNumber11(str) {
    console.log(str)
    str = str.replace(/[^\d]/g, '')
    if (str.length > 11) {
        str = str.slice(0, 11)
    }
    return str
}
const phone = {
    bind(el, binding, vnode) {
        el.inputMode = "numeric"
        el.type = "text"
    },
    inserted: function (el) {
        el.addEventListener("keypress", function (e) {
            e = e || window.event;
            let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
            let re = /\d/;
            if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
            }
        });
    },
    update(el, binding, vnode) {
        console.log(el)
        el.value = inputNumber11(el.value)
        el.dispatchEvent(new Event("input"))
    },
    componentUpdated(el, binding, vnode) {

    },
    unbind(el, binding, vnode) {

    },
}
Vue.directive("phone", phone)


// WEBPACK FOOTER //
// ./src/directive/index.js